import React from 'react';

import { Footer } from 'components/Footer';
import Header from 'components/Header';

export default function ImprintPage() {
  const stripedBg = {
    backgroundImage: 'repeating-linear-gradient(-45deg, var(--bg-stripe), var(--bg-stripe) 2px, var(--bg-body) 2px, var(--bg-body) 10px)',
    backgroundColor: 'var(--bg-body)',
  };

  return (
    <div style={stripedBg} className="min-h-screen w-full py-2 px-2 sm:py-8 sm:px-4 md:px-8 lg:px-12 flex justify-center font-sans text-slate-900 overflow-hidden">
      <div className="w-full bg-[var(--bg-box)] rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden border border-[var(--border-200)] flex flex-col relative shadow-sm">
        <Header />

        <main className="flex-grow">
          <section className="py-10 sm:py-16 md:py-24 px-2 sm:px-4 md:px-6 flex justify-center">
            <div className="w-full max-w-4xl bg-white rounded-xl md:rounded-[2rem] border border-gray-200 p-4 sm:p-8 md:p-10 lg:p-20 shadow-sm">
              <div className="mb-12">
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#2b3543] tracking-tight">
                  Imprint
                </h1>
                <p className="mt-6 text-slate-500 font-medium text-lg leading-relaxed">
                  Company registration details, contact information, legal disclosures, and website ownership information for Learn Social AI.
                </p>
              </div>

              <div className="space-y-8">
                <section className="border-t border-gray-100 pt-8">
                  <h2 className="text-xl font-extrabold text-[#2b3543] mb-4">Contact</h2>
                  <p className="text-slate-500 leading-relaxed font-medium">
                    Learn Social AI<br />
                    <a href="mailto:support@LearnSocialAI.net" className="text-[#2b3543] font-bold underline underline-offset-4 decoration-orange-400">
                      support@LearnSocialAI.net
                    </a>
                  </p>
                </section>

                <section className="border-t border-gray-100 pt-8">
                  <h2 className="text-xl font-extrabold text-[#2b3543] mb-4">Website Ownership</h2>
                  <p className="text-slate-500 leading-relaxed font-medium">
                    This website is operated by Learn Social AI. For legal notices, registration details, or ownership questions, contact us using the email address above.
                  </p>
                </section>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </div>
  );
}
